import "rxjs/add/operator/map";
import { stringify } from "querystring";
import { formatMessage } from "lib/globalize-util";
import { ActionsObservable } from "redux-observable";
import { ajax } from "lib/observable";
import siteConfig from "site-config";
import { ProductStyleInsights } from "models/insights/product-style-insights";
import type { FetchProductStyleInsightsAction } from "actions/insights/product-style-insights";
import { INSIGHTS } from "constants/action-types";
import { Observable } from "rxjs/Observable";
import type { IStore } from "reducers";
import type { ProductRankRouteResponse } from "types/insights/product-style-insight";

export const fetchProductStyleInsightsEpic = (action$: ActionsObservable<FetchProductStyleInsightsAction>, store) =>
    action$
        .ofType(INSIGHTS.FETCH_PRODUCT_STYLE_INSIGHTS.START)
        .switchMap(({ payload }: FetchProductStyleInsightsAction) => {
            const state: IStore = store.getState();
            const brandId = state.scope.brand._id;

            const query = {
                viewAsCompanyId: payload.viewAsCompanyId,
            };

            let url = "";

            if (payload.viewAsCompanyId) {
                url = `${siteConfig.orderInsightApi}/insights/brand/${brandId}/products/rank?${stringify(query)}`;
            } else {
                url = `${siteConfig.orderInsightApi}/insights/brand/${brandId}/products/rank`;
            }

            return ajax({
                url,
                method: "GET",
                withCredentials: true,
                crossDomain: true,
                headers: {
                    "Content-Type": "application/json",
                },
                handle401: false,
            })
                .flatMap(({ response, status }) => {
                    if (status !== 200) {
                        throw new Error(response.message || formatMessage("Unknown fetch error"));
                    }
                    const productsStyles = response as ProductRankRouteResponse;
                    return [
                        {
                            type: INSIGHTS.FETCH_PRODUCT_STYLE_INSIGHTS.COMPLETED,
                            productStyles: {
                                immediate: productsStyles?.immediate?.map(
                                    (product) => new ProductStyleInsights(product)
                                ),
                                prebook: productsStyles?.prebook?.map((product) => new ProductStyleInsights(product)),
                            },
                        },
                    ];
                })
                .catch((error) => {
                    return Observable.merge(
                        Observable.of({
                            type: INSIGHTS.FETCH_PRODUCT_STYLE_INSIGHTS.ERROR,
                            error: true,
                            payload: new Error("Error fetching product style insights"),
                        })
                    );
                });
        });
